<template>
	<b-container v-if="file.id" fluid>
		<h3><router-link :to="groupRoute">back</router-link></h3>
		<template v-if="file.filetype === 'image'">
			<p>{{ file.filename }}</p>
			<img :src="file.url" />
		</template>
		<template v-else>
			<a :href="file.url" target="_blank">{{ attachmentFilename }}</a>
		</template>
	</b-container>
</template>

<script>
import {mapActions} from 'vuex';

export default {
	name: 'File',
	data() {
		return {
			file: {},
		};
	},
	computed: {
		attachmentFilename() {
			if (!this.file.id) {
				return '';
			}

			return this.file.url.split(/.*[/|\\]/).pop().split('/').pop();
		},
		groupRoute() {
			return {
				name: 'group',
				params: {
					groupName: this.$route.params.groupName,
				},
			};
		},
	},
	async created() {
		this.file = await this.fetchFiles({id: this.$route.params.fileId});
	},
	methods: {
		...mapActions(['fetchFiles']),
	}
}
</script>

<style scoped>
	ul {
		padding: 0;
		list-style-type: none;
		width: 30%;
		margin-left: auto;
		margin-right: auto;
	}

	li {
		border: 1px solid white;
		border-radius: 3px;
		padding: 10px;
		margin-bottom: 10px;
		text-align: left;
		cursor: pointer;
	}

	li:hover {
		background-color: rgb(66, 185, 131);
	}
</style>
